import { Grid } from "antd";

/* eslint-disable no-restricted-globals */
export const useScreenSize = () => {
    return {
      width: screen.width,
      height: screen.height,
    };
  };
  
  export const useMdScreen = () => {
    const {height} = useScreenSize();
  
    if (height <= 768) {
      return true;
    }
    return false;
  };

  export const useMobileView = () => {
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    return !screens.md ;
  }
  
  